// IDE/ide/help/python.ts
import { HelpCategory } from "./types";

// Liste complète par défaut (Python) — harmonisée snake_case
export const PY_HELP_ITEMS: HelpCategory[] = [
    {
        name: "Mouvement",
        color: "#1677ff",
        snippets: [
            // ======== GÉNÉRAL ========
            { id: "walk", label: "walk()", code: `walk()` },

            // ======== RELATIF ========
            {
                id: "walk_choice",
                label: "walk_choice(direction)",
                code: `# direction = "FORWARD" ou "BACKWARD"\nwalk_choice("FORWARD")`,
            },
            {
                id: "walk_choice_by_unit",
                label: "walk_choice_by_unit(direction, distance)",
                code: `# direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_unit("FORWARD", 5)`,
            },

            // ======== PAR ID ========
            {
                id: "walk_by_id",
                label: "walk_by_id(id, distance)",
                code: `walk_by_id("charId", 1)`,
            },

            // ======== AVANT / ARRIÈRE ========
            { id: "walk_forward", label: "walk_forward()", code: `walk_forward()` },
            { id: "walk_backward", label: "walk_backward()", code: `walk_backward()` },

            // ======== AXES CARDINAUX ========
            { id: "walk_up", label: "walk_up()", code: `walk_up()` },
            { id: "walk_down", label: "walk_down()", code: `walk_down()` },
            { id: "walk_left", label: "walk_left()", code: `walk_left()` },
            { id: "walk_right", label: "walk_right()", code: `walk_right()` },

            // ======== DIAGONALES ========
            { id: "walk_left_up", label: "walk_left_up()", code: `walk_left_up()` },
            { id: "walk_left_down", label: "walk_left_down()", code: `walk_left_down()` },
            { id: "walk_right_up", label: "walk_right_up()", code: `walk_right_up()` },
            { id: "walk_right_down", label: "walk_right_down()", code: `walk_right_down()` },

            // ======== JUMP ========
            { id: "jump", label: "jump()", code: `jump()` },
            {
                id: "jump_choice",
                label: "jump_choice(direction)",
                code: `# direction = "FORWARD" ou "BACKWARD"\njump_choice("FORWARD")`,
            },
            {
                id: "jump_choice_by_unit",
                label: "jump_choice_by_unit(direction, distance)",
                code: `# direction = "FORWARD" ou "BACKWARD"\njump_choice_by_unit("BACKWARD", 3)`,
            },
            { id: "jump_forward", label: "jump_forward()", code: `jump_forward()` },
            { id: "jump_backward", label: "jump_backward()", code: `jump_backward()` },
            { id: "jump_up", label: "jump_up()", code: `jump_up()` },
            { id: "jump_down", label: "jump_down()", code: `jump_down()` },
            { id: "jump_left", label: "jump_left()", code: `jump_left()` },
            { id: "jump_right", label: "jump_right()", code: `jump_right()` },
            { id: "jump_left_up", label: "jump_left_up()", code: `jump_left_up()` },
            { id: "jump_left_down", label: "jump_left_down()", code: `jump_left_down()` },
            { id: "jump_right_up", label: "jump_right_up()", code: `jump_right_up()` },
            { id: "jump_right_down", label: "jump_right_down()", code: `jump_right_down()` },

            // ======== TURN ========
            { id: "turn", label: "turn(angle)", code: `turn(90)` },
            {
                id: "turn_right_or_left",
                label: "turn_right_or_left(direction)",
                code: `# direction = "RIGHT" ou "LEFT"\nturn_right_or_left("RIGHT")`,
            },
            {
                id: "choose_turn_angle",
                label: "choose_turn_angle(direction, angle)",
                code: `# direction = "RIGHT" ou "LEFT"\nchoose_turn_angle("LEFT", 45)`,
            },

            // ======== VARIABLES ========
            { id: "variable_walk", label: "variable_walk(distance)", code: `variable_walk(5)` },
            { id: "variable_jump", label: "variable_jump(height)", code: `variable_jump(2)` },
            { id: "variable_turn", label: "variable_turn(angle)", code: `variable_turn(120)` },
        ],
    },

    {
        name: "MouvementById",
        color: "#4096ff",
        snippets: [
            { id: "mbid_walk", label: "walk_by_id(id)", code: `walk_by_id("charId")` },

            {
                id: "mbid_walk_choice",
                label: "walk_choice_by_id(id, direction)",
                code: `# direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_id("charId", "FORWARD")`,
            },
            {
                id: "mbid_walk_choice_by_unit",
                label: "walk_choice_by_unit_by_id(id, direction, distance)",
                code: `# direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_unit_by_id("charId", "BACKWARD", 3)`,
            },

            { id: "mbid_walk_forward", label: "walk_forward_by_id(id)", code: `walk_forward_by_id("charId")` },
            { id: "mbid_walk_backward", label: "walk_backward_by_id(id)", code: `walk_backward_by_id("charId")` },

            { id: "mbid_walk_up", label: "walk_up_by_id(id)", code: `walk_up_by_id("charId")` },
            { id: "mbid_walk_down", label: "walk_down_by_id(id)", code: `walk_down_by_id("charId")` },
            { id: "mbid_walk_left", label: "walk_left_by_id(id)", code: `walk_left_by_id("charId")` },
            { id: "mbid_walk_right", label: "walk_right_by_id(id)", code: `walk_right_by_id("charId")` },

            { id: "mbid_walk_left_up", label: "walk_left_up_by_id(id)", code: `walk_left_up_by_id("charId")` },
            { id: "mbid_walk_left_down", label: "walk_left_down_by_id(id)", code: `walk_left_down_by_id("charId")` },
            { id: "mbid_walk_right_up", label: "walk_right_up_by_id(id)", code: `walk_right_up_by_id("charId")` },
            { id: "mbid_walk_right_down", label: "walk_right_down_by_id(id)", code: `walk_right_down_by_id("charId")` },

            { id: "mbid_jump", label: "jump_by_id(id, height)", code: `jump_by_id("charId", 1)` },
            {
                id: "mbid_jump_choice",
                label: "jump_choice_by_id(id, direction)",
                code: `# direction = "FORWARD" ou "BACKWARD"\njump_choice_by_id("charId", "FORWARD")`,
            },
            {
                id: "mbid_jump_choice_by_unit",
                label: "jump_choice_by_unit_by_id(id, direction, distance)",
                code: `# direction = "FORWARD" ou "BACKWARD"\njump_choice_by_unit_by_id("charId", "BACKWARD", 2)`,
            },
            { id: "mbid_jump_forward", label: "jump_forward_by_id(id)", code: `jump_forward_by_id("charId")` },
            { id: "mbid_jump_backward", label: "jump_backward_by_id(id)", code: `jump_backward_by_id("charId")` },
            { id: "mbid_jump_up", label: "jump_up_by_id(id)", code: `jump_up_by_id("charId")` },
            { id: "mbid_jump_down", label: "jump_down_by_id(id)", code: `jump_down_by_id("charId")` },
            { id: "mbid_jump_left", label: "jump_left_by_id(id)", code: `jump_left_by_id("charId")` },
            { id: "mbid_jump_right", label: "jump_right_by_id(id)", code: `jump_right_by_id("charId")` },
            { id: "mbid_jump_left_up", label: "jump_left_up_by_id(id)", code: `jump_left_up_by_id("charId")` },
            { id: "mbid_jump_left_down", label: "jump_left_down_by_id(id)", code: `jump_left_down_by_id("charId")` },
            { id: "mbid_jump_right_up", label: "jump_right_up_by_id(id)", code: `jump_right_up_by_id("charId")` },
            { id: "mbid_jump_right_down", label: "jump_right_down_by_id(id)", code: `jump_right_down_by_id("charId")` },

            { id: "mbid_turn", label: "turn_by_id(id, angle)", code: `turn_by_id("charId", 90)` },
            {
                id: "mbid_turn_right_or_left",
                label: "turn_right_or_left_by_id(id, direction)",
                code: `turn_right_or_left_by_id("charId", "RIGHT")`,
            },
            {
                id: "mbid_choose_turn_angle",
                label: "choose_turn_angle_by_id(id, direction, angle)",
                code: `choose_turn_angle_by_id("charId", "LEFT", 45)`,
            },

            { id: "mbid_variable_walk", label: "variable_walk_by_id(id, distance)", code: `variable_walk_by_id("charId", 5)` },
            { id: "mbid_variable_jump", label: "variable_jump_by_id(id, height)", code: `variable_jump_by_id("charId", 2)` },
            { id: "mbid_variable_turn", label: "variable_turn_by_id(id, angle)", code: `variable_turn_by_id("charId", 120)` },
        ],
    },

    {
        name: "Action",
        color: "#fa541c",
        snippets: [
            // ======== RECHERCHE / CRÉATION PERSOS ========
            { id: "addCharacter", label: "addCharacter(name, x, y)", code: `addCharacter("name", 200, 200)` },
            {
                id: "addCharacterWithSize",
                label: "addCharacterWithSize(name, x, y, width, height)",
                code: `addCharacterWithSize("name", 200, 200, 50, 50)`,
            },
            // {
            //     id: "find_character",
            //     label: "find_character(id)",
            //     code: `# Récupère l'entité Character par son ID\nfind_character("charId")`,
            // },

            // ======== COMMUNICATION ========
            { id: "say", label: "say(message)", code: `# Fait parler le perso par défaut\nsay("Hello!")` },
            { id: "say_by_id", label: "say_by_id(id, message)", code: `# Fait parler un perso spécifique\nsay_by_id("charId", "Hello!")` },

            // ======== AUTOPILOTE ========
            { id: "activate_autopilot", label: "activate_auto_pilot(id)", code: `# Démarre l'autopilote pour un perso\nactivate_auto_pilot("charId")` },
            { id: "desactivate_autopilot", label: "desactivate_auto_pilot(id)", code: `# Arrête l'autopilote pour un perso\ndesactivate_auto_pilot("charId")` },

            // ======== DÉPLACEMENT / TÉLÉPORTATION ========
            { id: "move_to", label: "move_to(id, x, y)", code: `# Téléporte un perso\nmove_to("charId", 100, 200)` },

            // ======== TAILLE ========
            { id: "change_size", label: "changeSize(id, newWidth, newHeight)", code: `# Modifie la taille d'un perso\nchangeSize("charId", 64, 64)` },

            { id: "set_win", label: "set_win()", code: `set_win()` },
        ],
    },

    {
        name: "Effects",
        color: "#faad14",
        snippets: [
            {
                id: "set_gravity",
                label: "set_gravity(enable, gravityY=None)",
                code: `# Active ou désactive la gravité\n# enable = True | False\nset_gravity(True)`,
            },
        ],
    },

    {
        name: "Objets",
        color: "#52c41a",
        snippets: [
            // ======== CRÉATION / SUPPRESSION ========
            { id: "add_object", label: "addObject(name, x, y)", code: `# Crée un objet et retourne son ID\nobj_id = addObject("name", 50, 50)` },
            { id: "addObjectWithSize", label: "addObjectWithSize(name, x, y, width, height)", code: `addObjectWithSize("name", 100, 100, 50, 50)` },
            { id: "add_pickable", label: "addPickable(name, x, y)", code: `obj_id = addPickable("name", 50, 50)` },
            { id: "addPickableWithSize", label: "addPickableWithSize(name, x, y, width, height)", code: `addPickableWithSize("name", 100, 100, 50, 50)` },
            { id: "add_decor", label: "addDecor(name, x, y)", code: `obj_id = addDecor("name", 50, 50)` },
            { id: "addDecorWithSize", label: "addDecorWithSize(name, x, y, width, height)", code: `addDecorWithSize("name", 100, 100, 50, 50)` },
            { id: "add_immovable", label: "addImmovable(name, x, y)", code: `obj_id = addImmovable("name", 50, 50)` },
            { id: "addImmovableWithSize", label: "addImmovableWithSize(name, x, y, width, height)", code: `addImmovableWithSize("name", 100, 100, 50, 50)` },
            { id: "add_pushable", label: "addPushable(name, x, y)", code: `obj_id = addPushable("name", 50, 50)` },
            { id: "addPushableWithSize", label: "addPushableWithSize(name, x, y, width, height)", code: `addPushableWithSize("name", 100, 100, 50, 50)` },
            { id: "destroy_object", label: "destroyObject(id)", code: `# Supprime l'objet\ndestroyObject(obj_id)` },

            // ======== TRANSFORMATION ========
            { id: "move_object", label: "moveObject(id, x, y)", code: `# Déplace l'objet existant\nmoveObject(obj_id, 150, 150)` },
            { id: "resize_object", label: "resizeObject(id, width, height)", code: `# Redimensionne l'objet\nresizeObject(obj_id, 80, 120)` },

            // ======== PICKABILITÉ ========
            { id: "activatePickable", label: "activatePickable(id)", code: `# Rend l'objet pickable\nactivatePickable(obj_id)` },
            { id: "activate_pick_order", label: "activatePickOrder(id, order)", code: `# Rend l'objet pickable avec l'ordre donné\nactivatePickOrder(obj_id, 1)` },
            { id: "desactivate_pick_order", label: "desactivatePickOrder(id)", code: `# Désactive complètement la pickabilité\ndesactivatePickOrder(obj_id)` },

            // ======== IMMOBILITÉ ========
            { id: "activate_immovable", label: "activateImmovable(id)", code: `# Verrouille l'objet en place\nactivateImmovable(obj_id)` },
            { id: "desactivate_immovable", label: "desactivateImmovable(id)", code: `# Rend à nouveau l'objet mobile\ndesactivateImmovable(obj_id)` },

            // ======== POUSSABILITÉ ========
            { id: "activate_pushable", label: "activatePushable(id)", code: `# Autorise le personnage à pousser l'objet\nactivatePushable(obj_id)` },
            { id: "desactivate_pushable", label: "desactivatePushable(id)", code: `# Interdit de pousser l'objet\ndesactivatePushable(obj_id)` },

            // ======== DÉCOR ========
            { id: "activate_decor", label: "activateDecor(id)", code: `# Activer le mode décor\nactivateDecor(obj_id)` },
            { id: "desactivate_decor", label: "desactivateDecor(id)", code: `# Retirer le mode décor\ndesactivateDecor(obj_id)` },

            // ======== REQUÊTE ========
            { id: "is_picked", label: "is_picked(id)", code: `# Teste si l’objet a déjà été ramassé\nis_picked("objectId")` },
        ],
    },

    {
        name: "Sons",
        color: "#a0d911",
        snippets: [
            { id: "play_sound", label: "play_sound(name)", code: `play_sound("laser")` },
            { id: "stop_sound", label: "stop_sound(name)", code: `stop_sound("laser")` },
            // (les alias playSound/stopSound existent aussi au runtime)
        ],
    },

    {
        name: "Text",
        color: "#2f54eb",
        snippets: [
            // ======== CRÉATION / SUPPRESSION ========
            { id: "create_text", label: "create(content, x, y)", code: `# id = create("Hello World", 100, 100)\nid_txt = create("Hello World", 100, 100)` },
            {
                id: "create_text_full",
                label: "create_full(content, x, y, font, size, color, bgColor)",
                code: `create_full("Hello World", 100, 100, "Arial", 18, "#000000", "#ffffff")`,
            },
            { id: "destroy_text", label: "destroy(id)", code: `destroy(id_txt)` },

            // ======== POSITION ========
            { id: "move_text", label: "move(id, x, y)", code: `move(id_txt, 150, 200)` },

            // ======== CONTENU ========
            { id: "set_text_content", label: "set_content(id, newContent)", code: `set_content(id_txt, "Nouveau contenu")` },
            { id: "add_text_content", label: "add_content(id, additionalText)", code: `add_content(id_txt, " plus de texte")` },
            { id: "replace_text_content", label: "replace_content(id, old, new)", code: `replace_content(id_txt, "old", "new")` },
            { id: "cut_text", label: "cut(id, start, end)", code: `cut(id_txt, 0, 5)` },
            { id: "reverse_text", label: "reverse(id)", code: `reverse(id_txt)` },
            { id: "to_uppercase", label: "to_uppercase(id)", code: `to_uppercase(id_txt)` },
            { id: "to_lowercase", label: "to_lowercase(id)", code: `to_lowercase(id_txt)` },

            // ======== STYLE ========
            { id: "set_text_font", label: "set_font(id, fontFamily)", code: `set_font(id_txt, "Comic Sans MS")` },
            { id: "set_font_size", label: "set_font_size(id, fontSize)", code: `set_font_size(id_txt, 20)` },
            { id: "set_text_color", label: "set_color(id, color)", code: `set_color(id_txt, "#ff0000")` },
            { id: "set_text_bg_color", label: "set_background_color(id, bgColor)", code: `set_background_color(id_txt, "#cccccc")` },

            // ======== REQUÊTE / ANALYSE ========
            { id: "get_text_content", label: "get_content(id)", code: `content = get_content(id_txt)` },
            { id: "find_word_position", label: "find_word_position(id, word)", code: `pos = find_word_position(id_txt, "Hello")` },
            { id: "replace_word", label: "replace_word(id, old, new)", code: `replace_word(id_txt, "old", "new")` },
            { id: "count_text_length", label: "count_length(id)", code: `n = count_length(id_txt)` },
            { id: "count_char_occurrences", label: "count_char_occurrences(id, char)", code: `n = count_char_occurrences(id_txt, "a")` },
        ],
    },

    {
        name: "Variables",
        color: "#13c2c2",
        snippets: [
            { id: "py_x_init", label: "x = 0", code: `x = 0` },
            { id: "py_message", label: 'message = "Hello"', code: `message = "Hello"` },
            { id: "py_update_x", label: "x = x + 1", code: `x = x + 1` },
            { id: "py_x_increment", label: "x += 1", code: `x += 1` },
            { id: "py_x_decrement", label: "x -= 1", code: `x -= 1` },
            { id: "py_x_plus_5", label: "x += 5", code: `x += 5` },
            { id: "py_x_minus_3", label: "x -= 3", code: `x -= 3` },
            { id: "py_print_x", label: "print(x)", code: `print(x)` },
        ],
    },

    {
        name: "Opérations",
        color: "#f5222d",
        snippets: [
            { id: "py_add", label: "Addition (+)", code: `somme = x + y` },
            { id: "py_sub", label: "Soustraction (-)", code: `diff = x - y` },
            { id: "py_mul", label: "Multiplication (*)", code: `prod = x * y` },
            { id: "py_div", label: "Division (/)", code: `quotient = x / y` },
            { id: "py_mod", label: "Modulo (%)", code: `reste = x % y` },
            { id: "py_and", label: "AND (and)", code: `if a > 0 and b > 0:\n    pass` },
            { id: "py_or", label: "OR (or)", code: `if a == 0 or b == 0:\n    pass` },
            { id: "py_not", label: "NOT (not)", code: `if not condition:\n    pass` },
        ],
    },

    {
        name: "Structures conditionnelles",
        color: "#fa8c16",
        snippets: [
            { id: "py_if", label: "if", code: `if condition:\n    # instructions si vrai\n    pass` },
            {
                id: "py_if_else",
                label: "if / else",
                code: `if condition:\n    # si vrai\n    pass\nelse:\n    # si faux\n    pass`,
            },
            {
                id: "py_if_elif_else",
                label: "if / elif / else",
                code: `if cond1:\n    pass\nelif cond2:\n    pass\nelse:\n    pass`,
            },
            {
                id: "py_match",
                label: "match (Python 3.10+)",
                code: `val = 2\nmatch val:\n    case 1:\n        pass\n    case 2:\n        pass\n    case _:\n        pass`,
            },
        ],
    },

    {
        name: "Structures répétitives",
        color: "#eb2f96",
        snippets: [
            { id: "py_for", label: "for", code: `for i in range(5):\n    print("i =", i)` },
            { id: "py_while", label: "while", code: `while condition:\n    # instructions\n    break  # retire si boucle réelle` },
            { id: "py_for_list", label: "for (liste)", code: `arr = [1, 2, 3]\nfor item in arr:\n    print(item)` },
        ],
    },

    {
        name: "Fonctions",
        color: "#9254de",
        snippets: [
            { id: "py_fn_simple", label: "def (simple)", code: `def ma_fonction():\n    print("Fonction appelée")` },
            { id: "py_fn_param", label: "def (avec param)", code: `def addition(a, b):\n    return a + b` },
            { id: "py_fn_no_return", label: "def (sans return)", code: `def dire_bonjour(nom):\n    print("Bonjour,", nom)` },
            { id: "py_random", label: "random (1..10)", code: `import random\nn = random.randint(1, 10)  # 1 ≤ n ≤ 10` },
            { id: "py_fn_call", label: "appel de fonction", code: `ma_fonction()` },
        ],
    },

    {
        name: "Listes (Tableaux)",
        color: "#722ed1",
        snippets: [
            { id: "py_empty_list", label: "arr = []", code: `arr = []` },
            { id: "py_list_numbers", label: "arr = [1, 2, 3]", code: `arr = [1, 2, 3]` },
            { id: "py_list_append", label: "arr.append(4)", code: `arr.append(4)` },
            { id: "py_list_pop", label: "arr.pop()", code: `arr.pop()` },
            { id: "py_list_access", label: "arr[0]", code: `print(arr[0])` },
            { id: "py_list_len", label: "len(arr)", code: `print(len(arr))` },
        ],
    },

    {
        name: "Events",
        color: "#faad14",
        snippets: [
            {
                id: "on_keyPress_enter",
                label: '@on_key_press("Enter")',
                code: `@on_key_press("Enter")\ndef on_enter(ev):\n    print("La touche Enter a été pressée")`,
            },
            {
                id: "on_keyPress",
                label: "@on_key_press(...) + déplacements",
                code: `@on_key_press("w", "d", "a", "s")\ndef handle_keys(ev):\n    key = ev["key"]\n    if key == "w":\n        walk_up()\n    elif key == "d":\n        walk_right()\n    elif key == "a":\n        walk_left()\n    elif key == "s":\n        walk_down()`,
            },

            {
                id: "on_collision",
                label: "@on_collision()",
                code: `@on_collision()\ndef on_hit(ev):\n    # ev["entityA"], ev["entityB"]\n    print("Collision détectée")`,
            },
            {
                id: "timer_once",
                label: "timer_once(sec)",
                code: `@timer_once(5)\ndef after_5s(ev):\n    # se déclenche une seule fois après 5 s\n    print("go!")`,
            },
            {
                id: "timer_during",
                label: "timer_during(sec)",
                code: `@timer_during(1)\ndef every_1s(ev):\n    # se déclenche toutes les 1 s\n    print("tic")`,
            },
            {
                id: "on_text_change",
                label: '@on_text_change("txt1")',
                code: `@on_text_change("txt1")\ndef on_text(ev):\n    # ev["textId"], ev["newText"], ev["oldText"]\n    say("Le texte a changé !")`,
            },
            {
                id: "on_pickup_any",
                label: "@on_pickup()   # n’importe quel ramassage",
                code: `@on_pickup()\ndef any_pick(ev):\n    # ev["charId"], ev["objId"]\n    print("pickup:", ev["charId"], ev["objId"])`,
            },
            {
                id: "on_pickup_char",
                label: '@on_pickup("hero")   # filtre perso',
                code: `@on_pickup("hero")\ndef hero_pick(ev):\n    print("Le héros vient de ramasser quelque chose !")`,
            },
            {
                id: "on_pickup_obj",
                label: '@on_pickup(None, "key01")   # filtre objet',
                code: `@on_pickup(None, "key01")\ndef key_pick(ev):\n    print("Quelqu’un a ramassé la clé !")`,
            },
        ],
    },
];
